"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyPageMode = exports.FieldType = void 0;
var FieldType;
(function (FieldType) {
    FieldType[FieldType["Undef"] = 0] = "Undef";
    FieldType[FieldType["String"] = 1] = "String";
    FieldType[FieldType["Digit"] = 2] = "Digit";
    FieldType[FieldType["Float"] = 3] = "Float";
    FieldType[FieldType["Date"] = 4] = "Date";
    FieldType[FieldType["Bool"] = 5] = "Bool";
    FieldType[FieldType["Time"] = 7] = "Time";
    FieldType[FieldType["DateTime"] = 8] = "DateTime";
    FieldType[FieldType["FixString"] = 9] = "FixString";
    FieldType[FieldType["FTKey"] = 10] = "FTKey";
    FieldType[FieldType["Image"] = 12] = "Image";
    FieldType[FieldType["BigDigit"] = 13] = "BigDigit";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
var PropertyPageMode;
(function (PropertyPageMode) {
    PropertyPageMode[PropertyPageMode["Search"] = 1] = "Search";
    PropertyPageMode[PropertyPageMode["View"] = 2] = "View";
    PropertyPageMode[PropertyPageMode["Edit"] = 3] = "Edit";
    PropertyPageMode[PropertyPageMode["New"] = 4] = "New";
})(PropertyPageMode = exports.PropertyPageMode || (exports.PropertyPageMode = {}));
